import produce from 'immer';
import { handleActions } from 'redux-actions';

const initialState = {};

export default handleActions(
  {
    'TELEMETRY/RESET': (state, action) => initialState,
    'TELEMETRY/INIT': (state, action) =>
      produce(state, (draft) => {
        const { robotId } = action.payload;

        draft[robotId] = {};
      }),
    'TELEMETRY/SET': (state, action) =>
      produce(state, (draft) => {
        const { robotId, key, data } = action.payload;

        draft[robotId][key] = data;
      }),
    'TELEMETRY/REMOVE': (state, action) =>
      produce(state, (draft) => {
        const { robotId } = action.payload;

        delete draft[robotId];
      }),
  },
  initialState
);
